class CustomerVideosSection {
  constructor(container) {
    this.container = container;
    this.layout = container.dataset.layout;
    this.hoverPlayDesktop = container.dataset.hoverPlayDesktop === 'true';
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
    
    this.videoCards = Array.from(container.querySelectorAll('[data-video-card]'));
    
    this.init();
    this.setupResizeObserver();
  }

  init() {
    this.videoCards.forEach(card => {
      const wrapper = card.querySelector('[data-video-wrapper]');
      const video = wrapper.querySelector('[data-video-player]');
      const toggleBtn = wrapper.querySelector('[data-video-toggle]');
      const iconPlay = wrapper.querySelector('[data-icon-play]');
      const iconPause = wrapper.querySelector('[data-icon-pause]');
      
      if (!video) return;

      const autoplay = video.hasAttribute('data-autoplay') || video.closest('[data-autoplay]');
      const loop = video.hasAttribute('loop');
      const startMuted = video.hasAttribute('muted');
      const hoverPlay = wrapper.dataset.hoverPlay !== 'false';
      
      let isMuted = startMuted;
      let isPlaying = false;

      // Sync icon avec état initial
      this.updateIcon(iconPlay, iconPause, isPlaying);

      // Click sur bouton overlay : toggle play/pause et unmute si demandé
      const handleToggle = () => {
        if (video.paused) {
          video.play().then(() => {
            isPlaying = true;
            this.updateIcon(iconPlay, iconPause, true);
            toggleBtn.setAttribute('aria-pressed', 'true');
            
            // Unmute au clic si l'option est activée
            const unmuteOnClick = wrapper.dataset.unmuteOnClick !== 'false';
            if (unmuteOnClick && isMuted) {
              video.muted = false;
              isMuted = false;
            }
          }).catch(() => {});
        } else {
          video.pause();
          isPlaying = false;
          this.updateIcon(iconPlay, iconPause, false);
          toggleBtn.setAttribute('aria-pressed', 'false');
        }
      };

      toggleBtn.addEventListener('click', handleToggle);

      // Clavier : Space/Enter
      toggleBtn.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          handleToggle();
        }
      });

      // Hover play sur desktop (si activé et pas reduced-motion)
      if (this.isDesktop && hoverPlay && this.hoverPlayDesktop && !this.prefersReducedMotion) {
        wrapper.addEventListener('mouseenter', () => {
          if (video.paused) {
            video.play().then(() => {
              isPlaying = true;
              this.updateIcon(iconPlay, iconPause, true);
              toggleBtn.setAttribute('aria-pressed', 'true');
            }).catch(() => {});
          }
        });

        wrapper.addEventListener('mouseleave', () => {
          if (!video.paused) {
            video.pause();
            isPlaying = false;
            this.updateIcon(iconPlay, iconPause, false);
            toggleBtn.setAttribute('aria-pressed', 'false');
          }
        });
      }

      // Mobile : tap sur la vidéo toggle play/pause
      if (!this.isDesktop) {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          handleToggle();
        });
      }

      // Sync icon quand la vidéo se termine
      video.addEventListener('ended', () => {
        isPlaying = false;
        this.updateIcon(iconPlay, iconPause, false);
        toggleBtn.setAttribute('aria-pressed', 'false');
      });

      // IntersectionObserver : pause quand hors écran
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && !video.paused) {
            video.pause();
            isPlaying = false;
            this.updateIcon(iconPlay, iconPause, false);
            toggleBtn.setAttribute('aria-pressed', 'false');
          }
        });
      }, { threshold: 0.5 });

      observer.observe(wrapper);
    });
  }

  updateIcon(playIcon, pauseIcon, isPlaying) {
    if (isPlaying) {
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
    } else {
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
    }
  }

  setupResizeObserver() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
      }, 100);
    });
  }
}

// Initialiser toutes les sections customer-videos
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-customer-videos]').forEach(container => {
    new CustomerVideosSection(container);
  });
});

// Support pour l'éditeur de thème Shopify
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-customer-videos]');
    if (container) {
      new CustomerVideosSection(container);
    }
  });
}

